import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';
import { useLanguage } from './LanguageContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    lang,
    toggleLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-svt-bg/80 backdrop-blur-md py-4 shadow-lg shadow-black/20' : 'bg-transparent py-6'}`} data-id="element-61">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-62">
        <a href="#" className="flex items-center gap-3 z-50" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/x3zgz2YSJzc57ZhT1dBqrP/logo.png" alt="SVT Dating Logo" className="h-7 sm:h-10 w-auto" data-id="element-64" />
          <span className="font-serif text-lg sm:text-2xl font-bold tracking-wide text-svt-text" data-id="element-65">
            SVT dating
          </span>
        </a>

        <div className="flex items-center gap-4" data-id="element-66">
          <button className="px-6 py-2.5 rounded-full border border-svt-pink/50 text-svt-pink-light hover:bg-svt-pink/10 transition-colors text-sm font-medium" data-id="element-67">
            {t('header.login')}
          </button>
          <button className="hidden sm:block px-6 py-2.5 rounded-full bg-gradient-primary text-white hover:opacity-90 transition-opacity text-sm font-medium shadow-[0_0_15px_rgba(232,67,147,0.4)]" data-id="element-68">
            {t('header.register')}
          </button>

          <div className="hidden md:flex items-center gap-2 ml-4" data-id="element-69">
            <div className="flex items-center bg-svt-overlay rounded-full p-1 border border-svt-border" data-id="element-70">
              <button onClick={theme === 'light' ? toggleTheme : undefined} className={`p-1.5 rounded-full transition-all duration-300 ${theme === 'dark' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-71">
                <Moon size={14} data-id="element-72" />
              </button>
              <button onClick={theme === 'dark' ? toggleTheme : undefined} className={`p-1.5 rounded-full transition-all duration-300 ${theme === 'light' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-73">
                <Sun size={14} data-id="element-74" />
              </button>
            </div>
            <div className="flex items-center bg-svt-overlay rounded-full p-1 border border-svt-border text-xs font-medium" data-id="element-75">
              <button onClick={lang === 'en' ? toggleLang : undefined} className={`px-3 py-1.5 rounded-full transition-all duration-300 ${lang === 'ru' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-76">
                RU
              </button>
              <button onClick={lang === 'ru' ? toggleLang : undefined} className={`px-3 py-1.5 rounded-full transition-all duration-300 ${lang === 'en' ? 'bg-gradient-primary text-white shadow-md' : 'text-svt-text-muted hover:text-svt-text'}`} data-id="element-77">
                EN
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}